export const startupDetailsEndpoint = "/api/startupdetails";
